import { React, useContext } from "react";
import { useNavigate } from 'react-router-dom'
import { Grid } from 'antd-mobile';
import { checkBindOpenId } from "api/api";
import { user, unit } from "utils/getImg";
import { UserContext } from "utils/getContext";
import { userType } from "utils/constant";
import 'static/css/loginEnter.css'

export function LoginEnter() {
  const navigate = useNavigate()
  const myContext = useContext(UserContext)
  const { setUserInfo } = myContext

  const { USER, UNIT } = userType

  /** 绑定用户openID，判断用户是否登录过 */
  async function checkoutOpenid(type) {
    const { data } = await checkBindOpenId(type)
    // 登录过
    if (data?.check) {
      setUserInfo({ ...data.data, type: type })
      navigate('/')
    } else { //未登录
      navigate('/login', {
        state: type === USER ? {
          name: 'name', id_name: 'idNum', type: USER, placeholder: '请输入身份证'
        } : {
          name: 'companyName', id_name: 'creditCode', type: UNIT, placeholder: '统一社会信用代码'
        }
      })
    }
  }

  return (
    <div className="loginEnter">
      <Grid columns={1} gap={30}>
        <Grid.Item>
          <img src={user} alt='用户' onClick={() => checkoutOpenid(USER)}></img>
        </Grid.Item>
        <Grid.Item>
          <img src={unit} alt='企业' onClick={() => checkoutOpenid(UNIT)}></img>
        </Grid.Item>
      </Grid >
    </div>
  )
}